import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { serverUrl, getAuthHeader } from ".";

export const useStaff = () => {
  return useQuery({
    queryKey: ["student"],
    queryFn: async () => {
      const response = await axios.get(`${serverUrl}/staff`, getAuthHeader());
      return response.data;
    },
  });
};
